import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
} from '../../../../utils/showToast'
import { errorService } from '../../../../service/ErrorService'
import { errorKeys } from '../../../../data/queryFactories'

export default function useRefuseErrorReportByUUIDMutation() {
  const queryClient = useQueryClient()

  const refuseErrorReportByUUIDMutation = useMutation({
    mutationFn: async (uuid) => {
      const { success, message } = await errorService.refuseByUuid(uuid)
      if (!success) {
        throw new Error(message.content)
      }
      return true
    },
    onMutate: async () => {
      showLoadingToast('Đang từ chối')
    },
    onError: (error) => {
      showErrorToast({
        message: 'Từ chối thất bại',
        error: error.message || 'không xác định',
      })
    },
    onSuccess: async (data) => {
      queryClient.invalidateQueries({ queryKey: errorKeys.all })
      showSuccessToast('Từ chối thành công')
    },
  })
  return { refuseErrorReportByUUIDMutation }
}
